import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actualizarEstadosCompactados, getVehiculosAcompactar } from "../../../../redux/actions";
import SuccessModal from "../../../../components/modals/successModal";
import ErrorModal from "../../../../components/modals/errorModal";
import CompactadosRow from "./compactadosRow";
import Button from "../../../../components/button";



function CompactadosComponent() {
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.currentUserId);

    const [checkedItems, setCheckedItems] = useState({});
    const [loading, setLoading] = useState(true);
    const [vehiculosAcompactar, setVehiculosAcompactar] = useState([]);
    const [fecha_hora, setFecha_hora] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [mostrarModalExito, setMostrarModalExito] = useState(false);
    const [mostrarModalError, setMostrarModalError] = useState(false);


    useEffect(() => {
        const obtenerFechaHoraArgentina = () => {
            const ahora = new Date();
            const opciones = {
                timeZone: "America/Argentina/Buenos_Aires",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            };

            const formatoArgentina = new Intl.DateTimeFormat("es-AR", opciones).format(ahora);

            // Formatear la fecha al estilo "YYYY-MM-DD HH:mm:ss"
            return formatoArgentina.replace(/\//g, "-").replace(",", "");
        };

        setFecha_hora(obtenerFechaHoraArgentina())
    }, []);


    const fetchVehiculosAcompactar = useCallback(async () => {
        setLoading(true);

        try {
            const response = await dispatch(getVehiculosAcompactar());
            setVehiculosAcompactar(response);
        } catch (error) {
            console.error(
                "Error al obtener los vehículos a compactar",
                error
            );
        } finally {
            setLoading(false);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchVehiculosAcompactar();
    }, [fetchVehiculosAcompactar]);

    const handleCheckChange = (id) => {
        setCheckedItems((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const seleccionarTodos = () => {
        const nuevosChecks = {};
        vehiculosAcompactar.forEach(({ id }) => {
            nuevosChecks[id] = true;
        });
        setCheckedItems(nuevosChecks);
    };

    const manejarActualizacionEstados = async () => {
        if (isSubmitting) return;

        const seleccionados = vehiculosAcompactar
            .filter(({ id }) => checkedItems[id])
            .map(({ id, Acta }) => ({
                id,
                nro: Acta?.nro || null,
                lugar: Acta?.lugar || null,
            }));

        if (seleccionados.length === 0) {
            setMostrarModalError(true);
            return;
        }

        setIsSubmitting(true);

        try {
            const finalData = {
                fecha_hora,
                seleccionados,
                userId,
            };

            await dispatch(actualizarEstadosCompactados(finalData));

            setMostrarModalExito(true);
        } catch (error) {
            console.error("Error al actualizar estados:", error);
            setMostrarModalError(true);
        } finally {
            setIsSubmitting(false);
        }
    };

    const closeSuccessModal = async () => {
        setMostrarModalExito(false);
        setCheckedItems({});

        await fetchVehiculosAcompactar();
    };

    return (
        <div className="bg-[#F5FAFF] flex flex-col justify-center">
            {mostrarModalExito && (
                <SuccessModal
                    closeSuccessModal={closeSuccessModal}
                />
            )}
            {mostrarModalError && (
                <ErrorModal closeErrorModal={() => setMostrarModalError(false)} message={"Ocurrió un error"} />
            )}
            <div className="flex  flex-col w-full h-full  p-5">
                <div className="text-[#687073] text-s font-medium font-inter">
                    Selecciona los vehículos que cambiarán su estado a "Compactado"
                </div>
            </div>


            <div className="mx-auto mb-[3rem] mt-[1rem] rounded-lg border border-[#c5dfff] flex flex-col overflow-hidden sm:w-[32rem] w-[20rem]">
                {/* Encabezado */}
                <div className="flex items-center bg-[#c5dfff] h-[3.5rem] px-4">
                    <div className="text-start text-[#0a5477] text-xs font-bold font-inter uppercase flex-[0.5]">
                        Nro Acta
                    </div>
                    <div className="text-center text-[#0a5477] text-xs font-bold font-inter uppercase flex-1">
                        Marca / Modelo
                    </div>
                    <div className="text-center text-[#0a5477] text-xs font-bold font-inter uppercase flex-1">
                        Dominio
                    </div>
                    <div className="text-center text-[#0a5477] text-xs font-bold font-inter uppercase flex-[0.5]">
                        <Button
                            type="button"
                            variant="secondary"
                            size="xs"
                            onClick={seleccionarTodos}
                        >
                            Seleccionar todos
                        </Button>
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-4">Cargando vehículos...</div>
                ) : (
                    vehiculosAcompactar?.map(({ Acta, Vehiculo, id }) => (
                        <CompactadosRow
                            key={id}
                            actaNro={Acta?.nro || "Sin Acta"}
                            marcaModelo={
                                Vehiculo
                                    ? `${Vehiculo.marcavh} / ${Vehiculo.modelovh}`
                                    : "Sin información"
                            }
                            dominio={Vehiculo?.dominio || "Sin dominio"}
                            checked={!!checkedItems[id]}
                            onCheck={() => handleCheckChange(id)}
                        />
                    ))
                )}
            </div>
            <Button
                size="md"
                loading={isSubmitting}
                disabled={isSubmitting}
                onClick={manejarActualizacionEstados}
                className="mx-auto mb-[3rem]"
            >
                Actualizar estados
            </Button>
        </div>
    );
}

export default CompactadosComponent;
